import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useParams } from '@rocketlane/rocket-router';
import { RoutePaths } from 'constant';
export const LegacySignalsAiAnalyticsConversationRedirect = ()=>{
    const { conversationId } = useParams();
    return /*#__PURE__*/ _jsx(Navigate, {
        replace: true,
        to: `${RoutePaths.customerPorfolioSignalsAiAnalytics}/${conversationId}`
    });
};
export const LegacySignalsAiAnalyticsIndexRedirect = ()=>/*#__PURE__*/ _jsx(Navigate, {
        replace: true,
        to: RoutePaths.customerPorfolioSignals
    });
